import { updateStoreApi } from '@apis/seller-center/profile-settings';
import { Modal, Toast } from '@common-web/index';
import { strings } from '@constants/strings';
import { setUserInfo } from '@reducers/seller-center/userinfo-slice';
import { getErrorString } from '@utils/utils';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const DisableVacationModal = ({ open = false, setOpen = () => {} }) => {
  const [disableLoading, setDisableLoading] = useState(false);
  const { userInfo } = useSelector((state) => state?.userData);
  const dispatch = useDispatch();

  const disableVacationMode = async () => {
    try {
      const body = { vacation_start_date: null, vacation_end_date: null, on_vacation: false };
      setDisableLoading(true);
      const res = await updateStoreApi(userInfo?.storeId, body);
      if (res.success) {
        Toast.success(strings.settings_updated_successfully);
        dispatch(
          setUserInfo({
            ...userInfo,
            userProfile: {
              ...userInfo?.userProfile,
              store: { ...userInfo?.userProfile?.store, ...body },
            },
          })
        );
        setOpen(false);
      }
    } catch (e) {
      Toast.error(getErrorString(e));
    } finally {
      setDisableLoading(false);
    }
  };

  return (
    <Modal
      title={strings?.disable_vacation_mode}
      open={open}
      width={580}
      showActions={true}
      okText={strings?.disable}
      handleOk={disableVacationMode}
      handleCancel={() => {
        setOpen(false);
      }}
      destroyOnClose={true}
      ModalBody={strings?.disable_vacation_mode_text}
      okButtonProps={{ loading: disableLoading }}
    />
  );
};

export default DisableVacationModal;
